import { pipe, Either, Task } from "fp";
import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as IndividualDriver from "~/IndividualDriver";
import * as Driver from "~/Driver";
import * as WorkCode from "~/WorkCode";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Individual driver requested" as const),
    reducer(
      ({ state }) =>
        (state.drivers.individualStore = Data.Store.requested(
          state.drivers.individualStore
        )) 
    ),
    effects(({ dispatch, state: { context, companies, drivers } }) =>
      pipe(
        IndividualDriver.Request.Get.request(companies.current, drivers.driverId)(context),
        Task.map((driver) => dispatch(Received.create(driver)))
      )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Individual driver requested" as const),
    creator((drivers?: Either.ErrorOr<Data.Cache.Cache<Driver.Driver>>) => ({
      drivers,
    })),
    reducer(
      ({ state, action: { drivers } }) =>
        (state.drivers.individualStore = Data.Store.received(drivers)(
          state.drivers.individualStore
        ) as typeof state.drivers.individualStore)
    ),
    effects(({ dispatch }) => dispatch(WorkCode.Action.Requested.create()))
  );
}

  